import React, { useEffect, useRef, useCallback, Fragment } from 'react';

import { useNavContext } from '../../util/context/NavContext';
import { useWindowSize } from '../../util/hooks/useWindowSize';

import cx from 'clsx';
import * as css from './Container.module.scss';

export type ContainerProps = {
    children: ReactNode;
    homepage?: boolean;
    theme?: 'dark' | 'white' | 'g10';
};
export function Container({ children, homepage, theme }: ContainerProps) {
    const { leftNavIsOpen, switcherIsOpen, toggleNavState } = useNavContext();
    const windowSize = useWindowSize();
    const lastWindowSize = useRef(windowSize);

    const closeNavs = useCallback(() => {
        toggleNavState('leftNavIsOpen', 'close');
        toggleNavState('switcherIsOpen', 'close');
    }, [toggleNavState]);

    useEffect(() => {
        const iwLast = lastWindowSize.current.innerWidth;
        const iwCurrent = windowSize.innerWidth;
        if (iwLast == null || iwCurrent == null) return;

        const windowShrinking = iwLast > iwCurrent;
        if (windowShrinking && iwCurrent < 1056) closeNavs();
        lastWindowSize.current = windowSize;
    }, [closeNavs, windowSize, windowSize.innerWidth]);
    const overlayVisible: boolean = (() => {
        const navOpen = leftNavIsOpen || switcherIsOpen;
        return !!navOpen && !!windowSize.innerWidth && windowSize.innerWidth < 1056;
    })();

    const containerClassNames = cx(
        'container',
        homepage && 'container--homepage',
        theme === 'dark' && 'container--dark',
        theme === 'white' && 'container--white',
        theme === 'g10' && 'container--g10',
    );

    return (
        <Fragment>
            <span hidden id="overlay-label">
                Collapse navigation items
            </span>
            <div
                role="button"
                aria-labelledby="overlay-label"
                tabIndex={0}
                className={cx(css.overlay, overlayVisible && css.visible)}
                onClick={closeNavs}
                onKeyDown={closeNavs}
            />
            <main id="main-content" aria-hidden={overlayVisible} className={containerClassNames} children={children} />
        </Fragment>
    );
}
